import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DateService } from '../../utils/date.service';

@Component({
    selector: 'dmv-pub-input-date',
    templateUrl: './input-date.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InputDateComponent {

    @Input() public formGroup: UntypedFormGroup;
    @Input() public myformControlName: string;
    @Input() public label: string = '';
    @Input() public id = `${this.label}-input_date`;
    @Input() public error: string;
    @Input() public message: string;
    @Input() public min = '1900-01-01';
    @Input() public max = '9999-12-31';
    @Output() public input: EventEmitter<Date> = new EventEmitter();

    constructor(public dateService: DateService, private translate: TranslateService) {
    }

    public get describedBy(): string {
        if (this.error) {
            return `${this.id}-error`;
        }
        if (this.message) {
            return `${this.id}-message`;
        }
        return null;
    }

    public get fullLabel(): Observable<string> {
        if (this.dateService.hasDateInput) {
            return of(this.label);
        }
        return this.translate.get('input_date.pattern').pipe(map((translation: string) => `${this.label} ${translation}`));
    }

    public emitDate(value: string | Date) {
        this.input.emit(this.toUtcDate(value));
    }

    private toUtcDate(date: Date | string): Date {
        if (!date) {
            return new Date();
        }
        if (typeof date === 'string') {
            return new Date(date);
        }
        return new Date(date.getTime());
    }
}
